export const REVIEW_CALCULATOR_REDIRECT_FR_URL = 'https://www.malou.io/outils/calculateur-avis-google';
export const REVIEW_CALCULATOR_REDIRECT_EN_URL = 'https://www.malou.io/en-us/tools/review-calculator';
export const PRIVACY_POLICY_EN_URL = 'https://www.malou.io/en-us/legal/privacy-policies';
export const PRIVACY_POLICY_FR_URL = 'https://www.malou.io/legal/politique-de-confidentialite';
export const COACHING_SESSIONS_PLANNER_URL = 'https://meetings-eu1.hubspot.com/angel-muyrong/diagnostic-meeting?utm_content=AppMaloupe';
export const MALOU_SITE_URL = 'https://malou.io/?utm_content=AppMaloupe';
export const EXPERT_DIAGNOSTIC_QUICK_CALL_FR = 'https://www.malou.io/demo';
export const EXPERT_DIAGNOSTIC_QUICK_CALL_EN = 'https://www.malou.io/en-us/demo';

// Event specific
export const WEEKEND_PARIS_GENERAL_CONDITIONS_EN_URL = 'https://www.malou.io/en-us/legal/general-conditions-fstec2025-weekend-paris';
